import React, { Component } from "react";
import { FormGroup, Modal, ModalBody } from 'reactstrap';
import { MdEdit, MdRemoveCircle } from 'react-icons/md';
import SurveyCheckQuestionEdit from 'components/edit/survey/SurveyCheckQuestionEdit';
import { writeDb } from "utils/API";

export class SurveyCheckQuestion extends Component {
    constructor(props) {
        super(props);
        const {submission} = this.props;
        this.state = {
            checkedIds: submission != null ? submission.checkedIds : {},
            editOpen: false,
        }
    }
    
    componentDidUpdate(prevProps) {
        const {submission} = this.props;
        if (prevProps.submission !== submission) {
            this.setState({
                checkedIds: submission != null ? submission.checkedIds : {},
                editOpen: false,
            });
        }
    }
    
    render() {
        const {survey, question, onChange, isReview, allowEdit} = this.props;
        const {checkedIds, editOpen} = this.state;

        const checked = checkedIds != null ? Object.values(checkedIds) : [];

        const options = [];
        if (question.options != null) {
            for (const [key, value] of Object.entries(question.options)) {
                options.push(
                    <div>
                        <input className='survey-option-icon' type="checkbox" name={question.id} checked={checked.includes(key)} disabled={isReview} onChange={e => {
                            if (e.target.checked) {
                                checkedIds[key] = key;
                            } else {
                                delete checkedIds[key];
                            }
                            this.setState({checkedIds: checkedIds});
                            if (onChange != null) {
                                onChange(checkedIds);
                            }
                        }}/>{' '}
                        <div className='survey-option-item'>{value.text}</div>
                    </div>
                );
            }
        }
        
        if (question != null && question.id != null) {
            return (
                <FormGroup key={question.id} tag="fieldset">
                    <div className='wrap-content-parent'>
                        <div className='wrap-content-fill-child'>
                            <h4 className='survey-question-text'>{question.text != null ? question.text : 'Check correct Ones.'}</h4>
                        </div>
                        {allowEdit && (
                            <div className='wrap-content-wrap-child'>
                                <MdEdit onClick={e=>{
                                    this.setState({editOpen: true});
                                }}/>
                                <MdRemoveCircle onClick={e=>{
                                    if (window.confirm("Are you sure to want to remove this question, it is permanent operation can not be undone?")) {
                                        writeDb('/survey/' + survey.id + '/questions/' + question.id, null);
                                    }
                                }}/>
                            </div>
                        )}
                    </div>
                    <FormGroup key='options' check>
                        {options}
                    </FormGroup>
                    {allowEdit && (
                        <Modal isOpen={editOpen}>
                            <ModalBody>
                                <SurveyCheckQuestionEdit 
                                    survey={survey}
                                    question={question}
                                    onSaveClick={(update)=> {
                                        if (this.props.onSaveClick != null) {
                                            this.props.onSaveClick(update)
                                        }
                                    }}
                                    onCloseClick={e=>{
                                        this.setState({editOpen: false});
                                    }} />
                            </ModalBody>
                        </Modal>
                    )}
                </FormGroup>
            );
        } else {
            return <div/>;
        }
    }
}

export default SurveyCheckQuestion;